import tyreSelections from './tyre-selections';
import tyreRefinements from './tyre-refinements';

export default class TyreStateManager {
  constructor() {
    this._ensureApplicationNamespace();
  }

  _ensureApplicationNamespace() {
    if (!window.Application) {
      window.Application = {};
    }
    if (!window.Application.tyres) {
      window.Application.tyres = {};
    }
  }

  getSelections() {
    if (!window.Application.tyres.selections) {
      this.setSelections();
    }
    return window.Application.tyres.selections;
  }

  setSelections(summary) {
    window.Application.tyres.selections = tyreSelections(summary);
    return window.Application.tyres.selections;
  }

  getRefinements() {
    return window.Application.tyres.refinements;
  }

  setRefinements(refinements) {
    window.Application.tyres.refinements = refinements;
  }

  getTyres() {
    if (!window.Application.tyres.tyres) {
      window.Application.tyres.tyres = {};
    }
    return window.Application.tyres.tyres;
  }

  setTyres(tyres) {
    window.Application.tyres.tyres = tyres;
  }

  getTyreBySupplierCode(supplierCode) {
    return this.getTyres().find((tyre) => tyre.supplier_code === supplierCode);
  }

  createRefinements(tyres) {
    return tyreRefinements(tyres);
  }
}
